// extracted by mini-css-extract-plugin
export var activeFilterButton = "_rz-c";
export var backButton = "_rz-4";
export var backIcon = "_rz-5";
export var chevronShortcut = "_rz-6";
export var container = "_rz-1";
export var editor = "_rz-8";
export var editorWrapper = "_rz-7";
export var prefix = "_rz-2";
export var searchIcon = "_rz-3";
export var suffix = "_rz-9";
export var suffixContent = "_rz-a";
export var suffixText = "_rz-b";
export var wrapper = "_rz-0";